import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon, _Glyphicon2;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Button from '../Button/index.js';
import Glyphicon from '../Glyphicon/index.js';
import Text from '../Text/index.js';

/**
 *  Header for Sidebar component
 *
 */
function SideBarHeader(_ref) {
  let {
    className,
    title,
    action,
    onHide,
    ...rest
  } = _ref;
  // Force action button to be small if no other size is defined
  if (action?.type === Button && !action?.props?.bsSize) {
    action = /*#__PURE__*/React.cloneElement(action, {
      bsSize: 'small'
    });
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "sideBarHeader",
    className: clsx(className, 'border-neutral-secondary border-horizontal-0 border-top-0 margin-bottom-2', 'display-flex justify-content-between align-items-center gap-3')
  }, rest), /*#__PURE__*/_jsx(Button, {
    bsStyle: "link",
    className: "text-size-500 text-subdued-lightest",
    onClick: onHide,
    "aria-label": "Back to main content"
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "chevron-left"
  }))), /*#__PURE__*/_jsx(Text, {
    size: 400,
    weight: "bold",
    className: "w-100 text-center"
  }, void 0, title), action ? /*#__PURE__*/_jsx("div", {}, void 0, action) : /*#__PURE__*/_jsx(Button, {
    bsStyle: "link",
    className: "text-size-500 text-subdued-lightest",
    onClick: onHide,
    "aria-label": "Close"
  }, void 0, _Glyphicon2 || (_Glyphicon2 = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "remove"
  }))));
}
export default SideBarHeader;